import { FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

type ContactAttributeFormFieldProps = {
  onClick: () => void;
} & PropsWithChildren;

export function ContactAttributeFormField({
  children,
  onClick,
}: ContactAttributeFormFieldProps): JSX.Element {
  return (
    <FlexBox gap="200" alignItems="center">
      {children}
      <IconButton variant="tertiary" icon="trash" onClick={onClick} />
    </FlexBox>
  );
}
